import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportName = "Abordagens de indivíduos por sexo"
const reportId = "individuals-sex"
const IndividualsSex = ({data}) => {

  useEffect(() => {
    const statusData = GraphicUtils.horizontalStackedBarChart(data, reportId, "sex");

    if (statusData) {
      const tableRows = statusData.labels.map((label, i) => [label, statusData.values[i]]);
      ReportUtils.createExportableTable(["Descrição", "Quantidade"], tableRows, "Abord. de indivíduos por sexo");
    }

  }, [data]);



  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName}</span>
        <div className="mt-1 flex gap-[3px] w-full" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default IndividualsSex;